import React from 'react';

import { Table } from 'reactstrap';
import PropType from 'prop-types';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

export default function ExportableTable(props) {
  const tBody = props.data;
  const tHead = props.head;

  // keys for iterator
  let trKey = 0;
  let tdKey = 0;
  let thKey = 0;

  return (
    <div>
      {props.exportable && <ReactHTMLTableToExcel
        id={props.id + '-export-button'}
        table={props.id}
        filename={props.filename}
        sheet={props.sheet}
        buttonText="Download as XLS"/>}
      <Table id={props.id} striped bordered hover>
        <thead>
        <tr>
          {tHead.map(
            head => (<th key={props.id + 'th' + thKey++}>{head}</th>)
          )}
        </tr>
        </thead>
        <tbody>
        {tBody.map(col => (<tr key={props.id + 'tr' + trKey++}>{col.map(row => (
          <td key={props.id + 'td' + tdKey++}>{row}</td>))}</tr>))}
        </tbody>
      </Table>
    </div>
  );
}

ExportableTable.propTypes = {
  id: PropType.string.isRequired,
  data: PropType.array.isRequired,
  head: PropType.array.isRequired,
  exportable: PropType.bool.isRequired,
  sheet: PropType.string.isRequired,
  filename: PropType.string.isRequired,
};

ExportableTable.defaultProps = {
  exportable: false,
  sheet: 'Sheet1',
  filename: 'export'
};


// WEBPACK FOOTER //
// ./src/components/ExportableTable/ExportableTable.js